/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { NewPessoaJuridica } from '../model/newPessoaJuridica';
import { PessoaJuridica } from '../model/pessoaJuridica';
import { UpdPessoaJuridica } from '../model/updPessoaJuridica';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';

@Injectable()
export class ClienteApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Excluir Cliente
     * 
     * @param clienteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ClienteClienteIdDelete(clienteId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1ClienteClienteIdDelete(clienteId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1ClienteClienteIdDelete(clienteId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1ClienteClienteIdDelete(clienteId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1ClienteClienteIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Cliente pelo Id
     * 
     * @param clienteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ClienteClienteIdGet(clienteId: number, observe?: 'body', reportProgress?: boolean): Observable<PessoaJuridica>;
    public v1ClienteClienteIdGet(clienteId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PessoaJuridica>>;
    public v1ClienteClienteIdGet(clienteId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PessoaJuridica>>;
    public v1ClienteClienteIdGet(clienteId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1ClienteClienteIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PessoaJuridica>('get',`${this.basePath}/v1/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Cliente
     * 
     * @param clienteId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ClienteClienteIdPut(clienteId: number, body?: UpdPessoaJuridica, observe?: 'body', reportProgress?: boolean): Observable<PessoaJuridica>;
    public v1ClienteClienteIdPut(clienteId: number, body?: UpdPessoaJuridica, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PessoaJuridica>>;
    public v1ClienteClienteIdPut(clienteId: number, body?: UpdPessoaJuridica, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PessoaJuridica>>;
    public v1ClienteClienteIdPut(clienteId: number, body?: UpdPessoaJuridica, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1ClienteClienteIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PessoaJuridica>('put',`${this.basePath}/v1/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Clientes
     * 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ClienteGet(withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<PessoaJuridica>>;
    public v1ClienteGet(withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PessoaJuridica>>>;
    public v1ClienteGet(withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PessoaJuridica>>>;
    public v1ClienteGet(withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PessoaJuridica>>('get',`${this.basePath}/v1/cliente`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Novo Cliente
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1ClientePost(body?: NewPessoaJuridica, observe?: 'body', reportProgress?: boolean): Observable<PessoaJuridica>;
    public v1ClientePost(body?: NewPessoaJuridica, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PessoaJuridica>>;
    public v1ClientePost(body?: NewPessoaJuridica, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PessoaJuridica>>;
    public v1ClientePost(body?: NewPessoaJuridica, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PessoaJuridica>('post',`${this.basePath}/v1/cliente`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
